import { API_CONFIG, apiUtils } from './config.js';

// Authentication API endpoints
const AUTH_ENDPOINTS = {
  REGISTER: '/auth/register',
  LOGIN: '/auth/login',
};

// Auth API functions
export const authApi = {
  // Register new school user and organization
  register: async (registerData) => {
    const url = `${API_CONFIG.BASE_URL}${AUTH_ENDPOINTS.REGISTER}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(registerData),
    });

    return apiUtils.handleResponse(response);
  },

  // Login school user
  login: async (loginData) => {
    const url = `${API_CONFIG.BASE_URL}${AUTH_ENDPOINTS.LOGIN}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginData),
    });

    const result = await apiUtils.handleResponse(response);
    
    // Store token in localStorage if login successful
    if (result.success && result.data?.access_token) {
      localStorage.setItem('authToken', result.data.access_token);
      localStorage.setItem('user', JSON.stringify(result.data.user));
      if (result.data.organization?.orgType) {
        localStorage.setItem('organizationType', result.data.organization.orgType);
      }
    }
    
    return result;
  },

  // Logout user
  logout: async () => {
    const token = localStorage.getItem('authToken');
    
    // Call logout endpoint to invalidate token on server
    if (token) {
      try {
        await fetch(`${API_CONFIG.BASE_URL}/auth/logout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
      } catch (error) {
        // Continue with local logout even if server call fails
      }
    }
    
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },

  // Get auth token
  getToken: () => {
    return localStorage.getItem('authToken');
  },
};

export default authApi;
